import React, { useState, useEffect, useRef } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment/min/moment-with-locales';
import { colors } from '../components/Theme/WebTheme';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import {Switch} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useNavigate, useLocation } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import BlankTable from 'components/BlankTable';
import dayjs from 'dayjs';

export default function Promos() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    editPromo
  } = api;
  const settings = useSelector(state => state.settingsdata.settings);
  const [role, setRole] = useState(null);
  const auth = useSelector(state => state.auth);
  const { state } = useLocation();

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);
  const handelShowPromo = (rowData) => {

    if (role === "admin" || role === "subadmin") {
      dispatch(editPromo({ ...rowData, promo_show: !rowData.promo_show }, "Update"))
    }
  };
  const inputRef = useRef(null);

  const columns = [
    { title: t('promo_name'), field: 'promo_name', },
    { title: t('description'), field: 'promo_description', },
    {
      title: t('type'),
      field: 'promo_discount_type',
      lookup: { flat: t('flat'), percentage: t('percentage') },
    },
    { title: t('promo_code'), field: 'promo_code' },
    { title: t('country'), field: 'country', },
    { title: t('promo_discount_value'), field: 'promo_discount_value', type: 'numeric', },
    { title: t('max_limit'), field: 'max_promo_discount_value', type: 'numeric', },
    { title: t('min_limit'), field: 'min_order', type: 'numeric', },
    {
      title: t('end_date'), field: 'promo_validity',
      editComponent: props => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            inputRef={inputRef}
            label="DateTimePicker"
            value={props.rowData.promo_validity ? dayjs(props.rowData.promo_validity) : dayjs()}
            onChange={(newValue) => {
              props.onChange(newValue)
            }}
          />
        </LocalizationProvider>
      ),
      render: rowData => rowData.promo_validity ? moment(rowData.promo_validity).format('lll') : null,
    },
    {
      title: t('show_in_list'), field: 'promo_show', type: 'boolean', render: (rowData) => (
        <Switch
          checked={rowData.promo_show}
          onChange={() => handelShowPromo(rowData)}
          disabled={!settings.AllowCriticalEditsAdmin}
        />
      ),
    },
    { title: t('promo_usage'), field: 'promo_usage_limit', type: 'numeric', },
    { title: t('promo_used_by'), field: 'user_avail', editable: 'never', }
  ];

  const [data, setData] = useState([]);
  const promodata = useSelector(state => state.promodata);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (promodata.promos) {
      setData(promodata.promos.map(promo => ({...promo})));
    } else {
      setData([]);
    }
  }, [promodata.promos]);

  const [selectedRow, setSelectedRow] = useState(null);

  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    setCurrentPage(state?.pageNo)
  }, [state])


  const handlePaginationChange = (page) => {
    setCurrentPage(page)
  };

  const options = {
    initialPage: state?.pageNo || 0,
    pageSize: 10,
    pageSizeOptions: [10, 15, 20],
    rowStyle: rowData => ({
      backgroundColor: (selectedRow === rowData.tableData.id) ? colors.THIRDCOLOR : colors.WHITE
    }),
    editable: {
      backgroundColor: colors.WHITE,
      fontSize: "0.8em",
      fontWeight: 'bold ',
      fontFamily: 'Lucida Console", "Courier New", monospace'
    },
    cellStyle: {
      border: "1px solid rgba(224, 224, 224, 1)",
      textAlign: "center",
    },
    headerStyle: {
      position: "sticky",
      textAlign: 'center',
      top: "0px",
      backgroundColor: colors.SECONDARY,
      color: colors.WHITE,
      fontSize: "0.8em",
      fontWeight: 'bold ',
      fontFamily: 'Lucida Console", "Courier New", monospace',
      border: "1px solid rgba(224, 224, 224, 1)",
      minWidth: "50px"
    },
    actionsColumnIndex: -1,
  }

  const localization = {
    body: {
      addTooltip: (t('add')),
      deleteTooltip: (t('delete')),
      editTooltip: (t('edit')),
      emptyDataSourceMessage: (
        (t('blank_message'))
      ),
      editRow: {
        deleteText: (t('delete_message')),
        cancelTooltip: (t('cancel')),
        saveTooltip: (t('save'))
      },
    },
    toolbar: {
      searchPlaceholder: (t('search')),
      exportTitle: (t('export')),
    },
    header: {
      actions: (t('actions'))
    },
    pagination: {
      labelDisplayedRows: ('{from}-{to} ' + (t('of')) + ' {count}'),
      firstTooltip: (t('first_page_tooltip')),
      previousTooltip: (t('previous_page_tooltip')),
      nextTooltip: (t('next_page_tooltip')),
      lastTooltip: (t('last_page_tooltip'))
    },
  }
  return (
    promodata.loading ? <CircularLoading /> :
      (data && data.length > 0 ?
        <MaterialTable
          title={t('promo_offer')}
          onChangePage={(page) => handlePaginationChange(page)}
          columns={columns}
          style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr', borderRadius: "8px", boxShadow: "4px 4px 6px #9E9E9E" }}
          data={data}
          onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
          options={options}
          localization={localization}
          editable={{
            onRowDelete: oldData =>
              settings.AllowCriticalEditsAdmin ?
                new Promise(resolve => {
                  setTimeout(() => {
                    resolve();
                    dispatch(editPromo(oldData, "Delete"));
                  }, 600);
                })
                :
                new Promise(resolve => {
                  setTimeout(() => {
                    resolve();
                    alert(t('demo_mode'));
                  }, 600);
                })
          }}
          actions={[
            {
              icon: 'add',
              tooltip: t("add_promo"),
              isFreeAction: true,
              onClick: (event) =>
                navigate(`/promos/addpromo`, { state: { pageNo: currentPage } })

            },
            (rowData) => ({
              tooltip: t("edit"),
              icon: () => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    marginRight: 0
                  }}
                >
                  <EditIcon />
                </div>
              ),
              onClick: (event, rowData) => {
                navigate(`/promos/updatepromo/${rowData.id}`, { state: { pageNo: currentPage } })
              }
            }),
          ]}
        />
        : <BlankTable title={t('promo_offer')} columns={columns} data={[]} options={options}
          localization={localization}
          actions={[
            {
              icon: 'add',
              tooltip: t("add_promo"),
              isFreeAction: true,
              onClick: (event) =>
                navigate(`/promos/addpromo`, { state: { pageNo: currentPage } })

            },
          ]}
        />)
  );
}
